export const brandTypeIcons = [
    { key: 'Combined', icon: '$combined-mark' },  
    { key: 'Word', icon: 'fa-light fa-input-text' },  
    { key: 'Figurative', icon: 'fa-light fa-image' },  
];